import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg, sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);
const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const modalStyle = css`

  :host {
    display: flex;
    --modal-header__padding-top: var(--_modal-header__padding-top, var(--sbkModalSpacingSmallScrTitleAreaInsetTop));
    --modal-header__padding-bottom: var(--_modal-header__padding-bottom, var(--sbkModalSpacingSmallScrTitleAreaInsetBottom));
    --modal-header__padding-right: var(--_modal-header__padding-right, var(--sbkModalSpacingSmallScrTitleAreaInsetRight));
    --modal-header__padding-left: var(--_modal-header__padding-left, var(--sbkModalSpacingSmallScrTitleAreaInsetLeft));
    --modal-header__gap: var(--modal-header__gap, var(--sbkModalSpacingSmallScrTitleAreaGap));
    --modal-button__padding: var(--_modal-button__padding, var(--sbkModalSpacingSmallScrButtonAreaInsetAll));
    --modal-button__gap: var(--_modal-button__gap, var(--sbkModalSpacingSmallScrButtonAreaGap));
    --modal-content__settings-divider-gap: var(--_modal-content__settings-divider-gap, var(--sbkModalSpacingSmallScrContentAreaSettingsDividerGapCopy));
    --modal-content__padding-top: var(--_modal-content__padding-top, var(--sbkModalSpacingSmallScrContentAreaInsetTop));
    --modal-content__padding-bottom: var(--_modal-content__padding-bottom, var(--sbkModalSpacingSmallScrContentAreaInsetBottom));
    --modal-content__padding-right: var(--_modal-content__padding-right, var(--sbkModalSpacingSmallScrContentAreaInsetRight));
    --modal-content__padding-left: var(--_modal-content__padding-left, var(--sbkModalSpacingSmallScrContentAreaInsetLeft));
    --modal-content__gap: var(--_modal-content__gap, var(--sbkModalSpacingSmallScrContentAreaGap));
    --modal-content__settings-headline-gap: var(--_modal-content__settings-headline-gap, var(--sbkModalSpacingSmallScrContentAreaSettingsHeadlineGap));
    --modal-title__font: var(--_modal-title__font, var(--sbkModalTypographySmallScrTitleSm));
    --modal-body__font: var(--_modal-body__font, var(--sbkModalTypographySmallScrBodySm));
    --modal-headline__font: var(--_modal-headline__font, var(--sbkModalTypographySmallScrHeadlineSm));

    --modal-background__color: var(--_modal-background__color, var(--sbkModalColorBgColorDefault));
    --modal-image__height: var(--_modal-image__height, var(--sbkModalSizingImageHeight));
    --modal__border: var(--sbkModalBorderBorder);
    --modal__color: var(--_modal__color, var(--sbkModalColorFgColorOnLightEnabled));
    --modal__border-radius: var(--_modal__border-radius, var(--sbkModalBorderRadiiusLg));
  }

  @media (min-width: ${breakpointLg}) {
    :host {
        --modal-header__padding-top: var(--_modal-header__padding-top, var(--sbkModalSpacingLargeScrTitleAreaInsetTop));
        --modal-header__padding-bottom: var(--_modal-header__padding-bottom, var(--sbkModalSpacingLargeScrTitleAreaInsetBottom));
        --modal-header__padding-right: var(--_modal-header__padding-right, var(--sbkModalSpacingLargeScrTitleAreaInsetRight));
        --modal-header__padding-left: var(--_modal-header__padding-left, var(--sbkModalSpacingLargeScrTitleAreaInsetLeft));
        --modal-header__gap: var(--_modal-header__gap, var(--sbkModalSpacingLargeScrTitleAreaGap));
        --modal-button__padding: var(--_modal-button__padding, var(--sbkModalSpacingLargeScrButtonAreaInsetBottom));
        --modal-button__gap: var(--_modal-button__gap, var(--sbkModalSpacingLargeScrButtonAreaGap));
        --modal-content__settings-divider-gap: var(--_modal-content__settings-divider-gap, var(--sbkModalSpacingLargeScrContentAreaSettingsDividerGap));
        --modal-content__padding-top: var(--_modal-content__padding-top, var(--sbkModalSpacingLargeScrContentAreaInsetTop));
        --modal-content__padding-bottom: var(--_modal-content__padding-bottom, var(--sbkModalSpacingLargeScrContentAreaInsetBottom));
        --modal-content__padding-right: var(--_modal-content__padding-right, var(--sbkModalSpacingLargeScrContentAreaInsetRight));
        --modal-content__padding-left: var(--_modal-content__padding-left, var(--sbkModalSpacingLargeScrContentAreaInsetLeft));
        --modal-content__gap: var(--_modal-content__gap, var(--sbkModalSpacingLargeScrButtonAreaGap));
        --modal-content__settings-headline-gap: var(--_modal-content__settings-headline-gap, var(--sbkModalSpacingLargeScrContentAreaSettingsHeadlineGap));
        --modal-title__font: var(--_modal-title__font, var(--sbkModalTypographyLargeScrTitleSm));
        --modal-body__font: var(--_modal-body__font, var(--sbkModalTypographyLargeScrBodySm));
        --modal-headline__font: var(--_modal-headline__font, var(--sbkModalTypographyLargeScrHeadlineSm));
      }
  }

  * {
    box-sizing: border-box;
  }

  dialog {
    width: auto;
    background-color: var(--modal-background__color);
    color: var(--modal__color);
    padding: 0;
    border: none;
    border-radius: var(--sbkModalBorderRadiiusLg);
    font: var(--modal-body__font);
    max-height: calc(100svh - var(--sbkModalSpacingSmallScrMarginTop) - var(--sbkModalSpacingSmallScrMarginBottom));
    margin: var(--sbkModalSpacingSmallScrMarginTop) var(--sbkModalSpacingSmallScrMarginLeftRight) var(--sbkModalSpacingSmallScrMarginBottom);

    @media (min-width: ${breakpointMd}) {
      margin: var(--sbkModalSpacingLargeScrMargin) auto;
      max-width: var(--sbkModalSizingMaxWidthMdViewport);
      max-height: calc(100vh - var(--sbkModalSpacingLargeScrMargin) - var(--sbkModalSpacingLargeScrMargin));
    }

    @media (min-width: ${breakpointLg}) {
      max-width: var(--sbkModalSizingMaxWidthLgViewport);
    }
  }
    
    dialog::backdrop {
        background-color: var(--sbkColorSelectableBgColorBackdropOverlayDefault);
    }

  [tabindex]:focus {
    outline: none; 
  }

  .modal__header {
    padding: var(--modal-header__padding-top) var(--modal-header__padding-right) var(--modal-header__padding-bottom) var(--modal-header__padding-left);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--modal-header__gap);
    font: var(--modal-title__font);
    box-shadow: 0px -40px 0px var(--modal-background__color);
    border-bottom: var(--sbkModalBorderTitleAreaBottom);
    position: sticky;
    top: 0;
    background-color: inherit;
    z-index: 1;
  }

    .modal__header h3 {
        font: var(--headline__text);
        margin: 0;
    }

    .scrolled {
        padding-top: 0;
    }

    .modal__content {
        display: flex;
        overflow-y: auto;
        flex-grow: 1;
        flex-direction: column;
        padding-top: var(--modal-content__padding-top);
        padding-bottom: var(--modal-content__padding-bottom);
        padding-right: var(--modal-content__padding-right);
        padding-left: var(--modal-content__padding-left);
        gap: var(--modal-content__gap);
    }

    .modal__footer {
        position: sticky;
        bottom: 0;
        display: flex;
        justify-content: center;
        padding: var(--modal-button__padding);
        box-shadow: 0px 20px 20px 5px var(--modal-background__color);
        flex-direction: column;
        gap: var(--modal-button__gap);
        align-items: center;
        background-color: var(--modal-background__color);

        @media (min-width: ${breakpointMd}) {
            flex-direction: row-reverse;
        }
    }


    .modal__footer--hidden {
      display: none;
    }

    .modal__content--settings::slotted(div) {
        border-bottom: var(--modal__border);
        padding-bottom: var(--modal-content__settings-divider-gap);
    }

    .modal__content--icon-wrapper {
        margin: 0 auto var(--sbkCoreSpacingSm) auto;
    }

    .modal__content--icon-wrapper .icon-24 {
        height: var(--modal-image__height);
        width: var(--modal-image__height);
    }
    
    sbk-round-button {
        --_round-button__color: var(--sbkRoundButtonBgColorOnDarkEnabled);
        --_round-button__color--active: var(--sbkRoundButtonBgColorOnDarkEnabled);
        --_round-button__color--hover: var(--sbkRoundButtonFgColorOnLightDefault);
        --_round-button__color--focus: var(--sbkRoundButtonBgColorOnDarkEnabled);
        --_round-button-icon-only__color: var(--sbkRoundButtonBgColorOnLightEnabled);

        --_round-button__bg: var(--sbkRoundButtonBgColorOnLightEnabled);
        --_round-button__bg--active: var(--sbkRoundButtonBgColorOnLightActive);
        --_round-button__bg--hover: var(--sbkRoundButtonBgColorOnLightHover);
        --_round-button__bg--focus: var(--sbkRoundButtonBgColorOnLightFocus);
        --_round-button-icon-only__bg: var(--sbkRoundButtonBgColorOnLightEnabledTransparent);

        --_round-button__border-color: var(--sbkRoundButtonBorderOnLightMarked);
        --_round-button__border-color--active: var(--sbkButtonBorderOnLightActive);
        --_round-button__border-color--hover: var(--sbkButtonBorderOnLightHover);
        --_round-button__border-color--focus: var(--sbkButtonBorderOnLightFocus);
    }
`;
